export default __webpack_public_path__ + "32b963b76fad14cd6b58a5a60397c35f.png";